import { JobTitle, JobTitleOption } from "./JobTitleSelector.types"

export const jobTitleToJobTitleOption = (jobTitle: JobTitle): JobTitleOption => ({
  value: jobTitle.id,
  label: jobTitle.title,

  data: { correlatedJobTitles: jobTitle.correlatedJobTitles || [] },
})
